import { render, staticRenderFns } from "./ProvinceCity.vue?vue&type=template&id=ef11bcc8&"
import script from "./ProvinceCity.vue?vue&type=script&lang=js&"
export * from "./ProvinceCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports